import { Alert, Divider, EmptyState, EventCard, Skeleton, Stack, Tag } from '@all-manager/design-system-v2';
import { Fragment } from 'react';
import NoHistoryIcon from '../../assets/no-historic.svg?react';
import EventMenuActions from '../ActivitiesTab/EventMenuActions/EventMenuActions';
import EventColorConfig from '../EventColorConfig/EventColorConfig';
import { useEventsTab } from './useEventsTab';

type Props = {
  subTopicId: string;
};

const SKELETON_ROWS = [0, 1, 2];

function TodayDivider() {
  return (
    <Divider>
      <Tag color="rendezVous" label="Aujourd'hui" />
    </Divider>
  );
}

export default function EventsTab(props: Props) {
  const { events, todayDividerIndex, isLoading, error, isAdmin } = useEventsTab(props);

  return (
    <Stack spacing={2}>
      {isAdmin ? <EventColorConfig subTopicId={props.subTopicId} /> : null}

      {isLoading ? (
        <Stack spacing={2} aria-busy="true" aria-label="Chargement des rendez-vous">
          {SKELETON_ROWS.map((row) => (
            <Skeleton key={row} variant="rounded" height={96} />
          ))}
        </Stack>
      ) : error ? (
        <Alert severity="error">
          Les rendez-vous n&apos;ont pas pu être chargés. Rechargez la page pour réessayer.
        </Alert>
      ) : events.length === 0 ? (
        <EmptyState
          title="Aucun rendez-vous"
          subtitle="Planifiez une visite ou une intervention avec « Nouvelle action » : elle apparaîtra ici et dans le planning."
          image={<NoHistoryIcon />}
        />
      ) : (
        events.map((event, index) => (
          <Fragment key={event.id}>
            {index === todayDividerIndex ? <TodayDivider /> : null}
            <EventCard event={event} action={<EventMenuActions event={event} />} />
            {todayDividerIndex === -1 && index === events.length - 1 ? <TodayDivider /> : null}
          </Fragment>
        ))
      )}
    </Stack>
  );
}
